// Utilitaires pour le texte enrichi saisi dans l'admin « Pages (contenu) »
// (gras, italique, souligné, taille, couleur — barre d'outils de l'éditeur).

// Balises produites par la barre d'outils de l'éditeur
const HTML_RE = /<(b|i|u|em|strong|s|span|font|br|div|p|ul|ol|li|a|h[1-6])(\s|>|\/)/i;

export function hasHtml(s) {
  return typeof s === "string" && HTML_RE.test(s);
}

// Nettoyage défensif (contenu saisi par l'admin seulement, mais on retire quand
// même script/style/iframe, les gestionnaires on* et les liens javascript:)
export function sanitizeHtml(html) {
  return String(html)
    .replace(/<\s*(script|style|iframe|object|embed|link|meta|form|input)[^>]*>[\s\S]*?<\s*\/\s*\1\s*>/gi, "")
    .replace(/<\s*\/?\s*(script|style|iframe|object|embed|link|meta|form|input)[^>]*\/?>/gi, "")
    .replace(/\son\w+\s*=\s*"[^"]*"/gi, "")
    .replace(/\son\w+\s*=\s*'[^']*'/gi, "")
    .replace(/\son\w+\s*=\s*[^\s>]+/gi, "")
    .replace(/(href|src)\s*=\s*(["']?)\s*javascript:[^"'>\s]*\2/gi, '$1="#"');
}

// Version texte brut (les balises sont retirées) — pour les attributs, liens tel:/sms:,
// balises <title> SEO et tout endroit où le HTML n'a pas sa place.
export function stripHtml(s) {
  return String(s)
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<li[^>]*>/gi, " • ")
    .replace(/<[^>]*>/g, "");
}

// Accepte une chaîne OU l'élément produit par t() pour un texte formaté — retourne
// toujours du texte brut (utile pour <title>, attributs, liens).
export function asPlainText(v) {
  if (typeof v === "string") return stripHtml(v);
  const html = v?.props?.dangerouslySetInnerHTML?.__html;
  return html ? stripHtml(html) : "";
}
